export const FETCH_DELETE_WASTE_BY_ID_REQUEST = 'FETCH_DELETE_WASTE_BY_ID_REQUEST'
export const FETCH_DELETE_WASTE_BY_ID_SUCCESS = 'FETCH_DELETE_WASTE_BY_ID_SUCCESS'
export const FETCH_DELETE_WASTE_BY_ID_FALUIRE = 'FETCH_DELETE_WASTE_BY_ID_FALUIRE'
